import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { IResponse } from "@app/lib/models/response.model";
import { AppConfiguration } from "@app/lib/services/app-config.service";
import { BaseHttpService } from "@app/lib/services/base-http.service";
import { ResetPassword } from "../models/reset-password.model";


@Injectable({
    providedIn: 'root'
})
export class ResetPasswordScreenService extends BaseHttpService {
  
  
 
    constructor(
        http: HttpClient,
        appConfig: AppConfiguration,
    ) {
        super(http, appConfig);
    }

     getUserForReset(queryparams:any) {
      return this.get<IResponse<ResetPassword[]>>('resetpassword-controller/search-user.htm',{params:queryparams});
    }


    resetPassword(queryParams: any) {
        return this.post<IResponse<any>,any>('resetpassword-controller/reset-password.htm',queryParams);
  }

   forceLogoff(queryParams: any) {
        const endpoint= `logoff-controller/force-logoff.htm?forceLogoffUserName=${queryParams.forceLogoffUserName}`
        return this.post<IResponse<any>,any>(endpoint);
  }
 

}